import { WebLayout } from "@/components/shared/layout/homepage";
import { SelectSlot } from "@/containers/select-slot";
import type { ServiceName } from "@/types/service";
import { useParams } from "@/components/hooks/use-params";

export const SelectSlotPage = () => {
  const { name } = useParams<{ name: ServiceName }>();
  if (!name) {
    return <div>404</div>;
  }
  return (
    <WebLayout>
      <SelectSlot name={name} />
    </WebLayout>
  );
};
